<template>
  <div
    class="pay-aside"
    v-if="payAsideState.show && isStore"
    :class="{ active: !!showPayAside }"
    :style="{
      'background-image': `url(${
        payAsideState['bg_' + nowLang.slice(-2)] || payAsideState.default_bg
      })`,
    }"
    @click="clickBtnUpload"
  >
    <a
      href="javascript:;"
      class="wrap"
      :class="{ active: showPayAside }"
      @click="handlePayAside(!showPayAside)"
    ></a>
    <a
      href="javascript:;"
      data-reason="payAside"
      data-type="goPay"
      class="go-btn ib"
      @click="goPay"
    >
      {{ $t("goPay") }}</a
    >
  </div>
</template>

<script lang="ts" setup>
import indexHook from "@/hooks/indexHook";
import { clickBtnUpload } from "@/utils/pointUtils";
import websiteConfig from "@/configs/websiteConfig";
import { nowLang } from "@/language";
import { openNewPageWithCidAndScid } from "@/utils/index";
import menuHook from '@/hooks/menuHook';
const { isStore } = menuHook();

const { showPayAside, handlePayAside } = indexHook();
const payAsideState = websiteConfig.payAside;
setTimeout(() => {
  showPayAside.value = false;
}, 3000);
const goPay = () => {
  openNewPageWithCidAndScid({
    link: payAsideState.payLink,
    type: "sliderbanner",
    otherParams: {
      language: nowLang.value,
    },
  });
};
</script>
